import { DateRange } from './DateRange';
import moment from 'moment';

export default class DataRangeSlicer {
    public slice(start: Date, end: Date, daysInSlice: number, truncateToEnd: boolean = false): DateRange[] {
        const slices = new Array<DateRange>();
        let current = moment(start);
        const mend = moment(end);
        while (current.unix() < mend.unix()) {
            const e = moment(current).add(daysInSlice, 'days').subtract(1, 'millisecond');
            const slice = truncateToEnd ? new DateRange(current.toDate(), e > mend ? mend.toDate() : e.toDate()) :
                new DateRange(current.toDate(), e.toDate());
            slices.push(slice);
            current = moment(current).add(daysInSlice, 'days');
        }
        return slices;
    }
}
